// CSV + percentage helpers + email builder

export function computeServeInPctNumber(d) {
  const att = Number(d.serveAttempts || 0);
  const err = Number(d.serviceErrors || 0);
  if (!att) return 0;
  const inCount = Math.max(0, Math.min(att, att - err));
  return Math.round((inCount / att) * 100);
}

export function computeAcePctNumber(d) {
  const att = Number(d.serveAttempts || 0);
  const ac = Number(d.aces || 0);
  if (!att) return 0;
  const a = Math.max(0, Math.min(att, ac));
  return Math.round((a / att) * 100);
}

export function computeKillPctNumber(d) {
  const hits = Number(d.attackAttempts || 0);
  const k = Number(d.kills || 0);
  const he = Number(d.hittingErrors || 0);
  const totalAttempts = hits + k + he;
  if (!totalAttempts) return 0;
  return Math.round((k / totalAttempts) * 100);
}

// utils/stats.js
export function escapeCsv(raw = "") {
  const s = String(raw ?? "");
  // Prevent Excel formula injection
  const guarded = /^[=+\-@]/.test(s) ? `'${s}` : s;
  const needsQuote = /[",\n]/.test(guarded);
  const escaped = guarded.replace(/"/g, '""');
  return needsQuote ? `"${escaped}"` : escaped;
}


export function toRowCsv(m) {
  const statLabels = ["Sets","Assists","Kills","Serve Attempts","Service Errors","Aces","Digs"];
  const keys = ["sets","assists","kills","serveAttempts","serviceErrors","aces","digs"];
  const headers = ["Player Name","Match Date","Opponent",...statLabels];
  const row = [
    escapeCsv(m.playerName || ""),
    escapeCsv(m.matchDate || ""),
    escapeCsv(m.opponent || ""),
    ...keys.map(k => String(m[k] ?? 0)),
  ];
  return [headers.join(","), row.join(",")].join("\n");
}

export function buildMailto({ data, csv }) {
  if (!data.email) return "";
  const subject =
    `Volleyball Stats — ${data.playerName || "Player"} vs ${data.opponent || "Opponent"} (${data.matchDate || "Date"})`;
  const bodyLines = [
    `Player: ${data.playerName || ""}`,
    `Date: ${data.matchDate || ""}`,
    `Opponent: ${data.opponent || ""}`,
    "",
    "Sets: " + (data.sets ?? 0),
    "Assists: " + (data.assists ?? 0),
    "Kills: " + (data.kills ?? 0),
    "Serve Attempts: " + (data.serveAttempts ?? 0),
    "Service Errors: " + (data.serviceErrors ?? 0),
    "Aces: " + (data.aces ?? 0),
    "Digs: " + (data.digs ?? 0),
    "",
    "Serving Percentage: " + computeServeInPctNumber(data) + "%",
    "Kill Percentage: " + computeKillPctNumber(data) + "%",
    "Ace Percentage: " + computeAcePctNumber(data) + "%",
    "",
    "CSV:",
    csv,
  ];
  return `mailto:${encodeURIComponent(data.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(bodyLines.join("\n"))}`;
}
